import OMT_VILLAINS from '../../OMT_UI/OMT_Villains';

const width = 640;
const height = 1242;

const convertToPercentageX = (x) => (x / width) * 100;
const convertToPercentageY = (y) => (y / height) * 100;

const yOffset = 52;

export default [
  {
    texture: OMT_VILLAINS.getPrefixedName('villain_1_1'),
    destroyOnComplete: true,
    landscape: {
      baseWidth: width,
      baseHeight: height,
      scaleCoeff: {
        scale: 1.5,
      },
    },
    transforms: [
      // Initial transform
      {
        alpha: 1,
        x: convertToPercentageX(91),
        y: convertToPercentageY(186 + yOffset),
        callback: (object) => {
          object.scale.setTo(0.45);
          object.scale.x *= -1;
        },
      },
      {
        wait: 1500,
        callback: () => {
          G.sfx.exchange.play();
        },
      },
      {
        x: convertToPercentageX(540),
        y: convertToPercentageY(133 + yOffset),
        duration: 400,
      },
      {
        x: convertToPercentageX(900),
        y: convertToPercentageY(186 + yOffset),
        duration: 400,
      },
      {
        x: convertToPercentageX(1436),
        y: convertToPercentageY(136 + yOffset),
        duration: 400,
      },
    ],
  },
  {
    texture: OMT_VILLAINS.getPrefixedName('hard_corruption'),
    destroyOnComplete: true,
    landscape: {
      scaleCoeff: {
        scaleX: 3,
        scaleY: 2,
      },
    },
    transforms: [
      {
        x: convertToPercentageX(307),
        y: convertToPercentageY(539),
        alpha: 1,
        angle: 90,
        scale: 5.4,
      },
      {
        scale: 5.04,
        duration: 34,
      },
      {
        y: convertToPercentageY(655),
        duration: 135,
      },
      {
        alpha: 0,
        y: convertToPercentageY(1070),
        duration: 466,
      },
    ],
  },
];
